import gql from 'graphql-tag';

// This is called with graphql-tag because server side can't read the graphql files
const popularDestinationsQuery = gql`
    query fetchImageData($req: DestinationImageInput) {
        destinationImage(destinationImageRequest: $req) {
            name
            content {
                image {
                    audit {
                        errorMessage
                        status
                    }
                    info {
                        url
                    }
                }
            }
        }
    }
`;

export default popularDestinationsQuery;
